<template>
	<div>
		<div class="footer_wrap">
			<div class="footer_lalanita_1v">
				<div class="footer_lalanita_1vtop">
					<div class="footer_lalanita_1vtop_t">LaLANITA, KARYWORLD, S.A. DE C.V., SOFOM, E.N.R.</div>
					<div class="footer_lalanita_1vtop_x">
						Condiciones del préstamo: Monto del préstamo oscilan entre MXN 200 y MXN 20,000. Plazo de pago mínimos y máximos: 90 días a 24 meses, dependiendo de los requisitos del cliente y los productos crediticios aprobados. La TAE máxima (tasa porcentual anual) se fija en un porcentaje máximo del 36% anual y el porcentaje mínimo se fija en el 3% anual. Tasa de interés: Tasa de interés fija. CAT información media: 453,4%, sin IVA. Un ejemplo representativo del costo total del crédito incluyendo comisiones e intereses es el siguiente: Por $10,000 pagarías $13,600 más IVA intereses (calculado a una tasa diaria del 0,3% y un plazo de 120 días). En caso de no obtener respuesta satisfactoria, podrá acudir a la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF): Tel. 55 53 400 999
					</div>
				</div>
				<div class="footer_lalanita_1vdon">
					<div class="footer_lalanita_1vdleft">
						<div class="footer_lalanita_1vdltx">Contáctanos</div>
						<div class="footer_lalanita_1vdltx"></div>
						<div class="footer_lalanita_1vdltx">Teléfonos: 5590599377</div>
						<div class="footer_lalanita_1vdltx">Correo: servicioplus@lalanitaplus.com</div>
						<div class="footer_lalanita_1vdltx" @click.stop="gotoPrivacy">Aviso de Privacidad</div>
						<div class="footer_lalanita_1vdltx" @click.stop="gotoProvision">Términos y Condiciones</div>
					</div>
					<div class="footer_lalanita_1vdrigt">
						<div class="footer_lalanita_1vdr_v">
							<a
									href="https://www.facebook.com/profile.php?id=61583928676835"
									target="_blank"
									class="playBtn"
							>
							<div class="footer_lalanita_1vdr_vmg">
								<img src="../assets/imgs/facebook_2.webp" alt="">
							</div>
							</a>
							<a
									href="https://www.instagram.com/lalanitaplus?igsh=cngyMjZpNWN2emF5"
									target="_blank"
									class="playBtn"
							>
							<div class="footer_lalanita_1vdr_vmg">
								<img src="../assets/imgs/instagram_2.webp" alt="">
							</div>
							</a>
							<a
									href="https://www.tiktok.com/@lalanitaplus?_r=1&_t=ZS-91fhCwGKPCe"
									target="_blank"
									class="playBtn"
							>
							<div class="footer_lalanita_1vdr_vmg">
								<img src="../assets/imgs/tiktok_2.webp" alt="">
							</div>
							</a>
							<a
									href="https://www.youtube.com/@LaLanitaPlus"
									target="_blank"
									class="playBtn"
							>
							<div class="footer_lalanita_1vdr_vmg">
								<img src="../assets/imgs/youtube.webp" alt="">
							</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer_lalanita_1v_copyrit">
			<span>Todos los derechos reservados © 2025 KARYWORLD, S.A. DE C.V., SOFOM, E.N.R.</span>
		</div>
	</div>
</template>

<script>
	import './scss/foot.scss'

	export default {
		name: 'footPage',
		data() {
			return {
				isPrivacy: false,
				isPrivacyAgreement: false,
				isProvision: false,
			}
		},
		mounted() {
			let usePath = this.$route.path

			if (usePath.indexOf('privacy') != -1) {
				this.isPrivacy = true
			} else {
				this.isPrivacy = false
			}

			if (usePath.indexOf('pricacyagreement') != -1) {
				this.isPrivacyAgreement = true;
			} else {
				this.isPrivacyAgreement = false;
			}

			if (usePath.indexOf('provision') != -1) {
				this.isProvision = true
			} else {
				this.isProvision = false
			}
		},
		methods: {
			gotoPrivacy() {
				this.$router.push({
					path: '/privacy',
				})
			},
			gotoPrivacyAgreement() {
				this.$router.push({
					path: '/pricacyagreement',
				})
			},
			gotoProvision() {
				this.$router.push({
					path: '/provision',
				})
			},
		},
	}
</script>
